import { render, staticRenderFns } from "./electoral_roll_multiple_spd.vue?vue&type=template&id=0cab741e"
import script from "./electoral_roll_multiple_spd.vue?vue&type=script&lang=js"
export * from "./electoral_roll_multiple_spd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports